import {
  List as MuiList,
  ListItem as MuiListItem,
  ListItemAvatar as MuiListItemAvatar,
  type ListItemAvatarProps as MuiListItemAvatarProps,
  ListItemButton as MuiListItemButton,
  type ListItemButtonProps as MuiListItemButtonProps,
  ListItemIcon as MuiListItemIcon,
  type ListItemIconProps as MuiListItemIconProps,
  type ListItemProps as MuiListItemProps,
  ListItemText as MuiListItemText,
  type ListItemTextProps as MuiListItemTextProps,
  type ListProps as MuiListProps,
  ListSubheader as MuiListSubheader,
  type ListSubheaderProps as MuiListSubheaderProps
} from "@mui/material";

export type ListProps = MuiListProps;
export type ListItemProps = MuiListItemProps;
export type ListItemButtonProps = MuiListItemButtonProps;
export type ListItemTextProps = MuiListItemTextProps;
export type ListItemIconProps = MuiListItemIconProps;
export type ListItemAvatarProps = MuiListItemAvatarProps;
export type ListSubheaderProps = MuiListSubheaderProps;

export const List = MuiList;
export const ListItem = MuiListItem;
export const ListItemButton = MuiListItemButton;
export const ListItemText = MuiListItemText;
export const ListItemIcon = MuiListItemIcon;
export const ListItemAvatar = MuiListItemAvatar;
export const ListSubheader = MuiListSubheader;
